import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slice/authSlice';
import paginationReducer from './slice/paginationSlice';
import filterReducer from './slice/filterSlice';
import blogReducer from './slice/blogSlice';
import searchReducer from './slice/searchSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    pagination: paginationReducer,
    filter: filterReducer,
    blog: blogReducer,
    search: searchReducer,
  },
});

window._reduxStore = store;

export default store;
